import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as myConstList from "../Common/BaseUrl";
import DocumentMeta from "react-document-meta";
import LoginHeader from "../Common/LoginHeader";
import Footer from "../Common/Footer";
import { ProductName } from "../Common/ProductName";
import {
  useTransGetSpotListMutation,
  useTransCurrenciesQuery,
} from "../../redux/TransactionApi";
import { Decimal_util } from "../../utils/Dec.util";

const SpotHistoryFunction = () => {
  const meta = {
    title: `Spot Transactions | ${ProductName} Exchange`,
    description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName} Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const { data: currencies } = useTransCurrenciesQuery();
  const [transGetSpotList] = useTransGetSpotListMutation();

  const [currencyId, setCurrencyId] = useState(1);
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    itemsPerPage: 50,
    totalItems: 0,
  });

  // Fetch transactions whenever currencyId or currentPage changes
  useEffect(() => {
    const fetchSpotTransactions = async () => {
      const payload = {
        page: pagination.currentPage,
        limit: pagination.itemsPerPage,
        currency_id: currencyId,
      };

      const { data, error } = await transGetSpotList(payload);
      if (data?.status) {
        setTransactions(data.data || []);
        setPagination((prev) => ({
          ...prev,
          currentPage: data.pagination.currentPage,
          totalPages: data.pagination.totalPages,
          totalItems: data.pagination.totalItems,
        }));
      }
    };

    fetchSpotTransactions();
  }, [currencyId, pagination.currentPage, transGetSpotList]);

  // Currency tab list
  const renderCoinList = () =>
    currencies?.data?.map((item) => (
      <li
        key={item.id}
        onClick={() => {
          setCurrencyId(item.id);
          setPagination((prev) => ({ ...prev, currentPage: 1 }));
        }}
      >
        <span className={currencyId === item.id ? "active" : ""}>
          {item.symbol}
        </span>
      </li>
    ));

  // Table rows
  const renderTableRows = () =>
    transactions.map((e, i) => (
      <tr key={e.id}>
        <td>{i + 1}</td>
        <td>{e.tx_type}</td>
        <td>{Decimal_util.fixedtillString(e.amount, 8)}</td>
        <td className="ip_width">{e.tx_hash}</td>
        <td>{e.symbol}</td>
        <td className="td_date">{e.created}</td>
        <td className="text-capital">{e.status}</td>
      </tr>
    ));

  // Pagination buttons
  const renderPagination = () => {
    if (pagination.totalPages <= 1) return null;

    return (
      <div className="pagination-controls mt-3">
        <button
          className="btn"
          disabled={pagination.currentPage === 1}
          style={{ opacity: pagination.currentPage === 1 ? 0.5 : 1 }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage - 1,
            }))
          }
        >
          Prev
        </button>
        <span className="m-3">
          Page {pagination.currentPage} of {pagination.totalPages} (
          {pagination.totalItems} records)
        </span>
        <button
          className="btn"
          disabled={pagination.currentPage === pagination.totalPages}
          style={{
            opacity: pagination.currentPage === pagination.totalPages ? 0.5 : 1,
          }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage + 1,
            }))
          }
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <DocumentMeta {...meta}>
      <div>
        <LoginHeader />
        <div className="bg_light">
          <div className="new_inpage">
            <div className="container container2">
              <div className="white_box">
                <ul className="nav nav-tabs2 mb-3">
                  <li className="nav-item">
                    <Link to="/mainWalletTransactions"> Main Wallet </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/spotHistory" className="active">
                      Spot
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/coinDeposite"> Deposit Coin </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/coinFundRequest"> Withdrawal </Link>
                  </li>
                </ul>

                <ul className="nav nav-tabs offer_beu spot">
                  {renderCoinList()}
                </ul>

                <div className="tab-content">
                  <div className="tab-pane active" id="Balance">
                    <div className="top_balance"></div>
                    <div className="rows">
                      <div className="wallet_box">
                        <div className="table-responsive">
                          <div className="scrool_wallet_box">
                            <table className="table table-striped mb-0">
                              <thead>
                                <tr>
                                  <th>Sr. No.</th>
                                  <th>Transaction Type</th>
                                  <th>Amount</th>
                                  <th className="ip_width">Transaction ID</th>
                                  <th>Currency Type </th>
                                  <th>Date & Time</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transactions.length > 0 ? (
                                  renderTableRows()
                                ) : (
                                  <tr>
                                    <td colSpan="7" className="text-center">
                                      No Transactions Found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {renderPagination()}
                      </div>
                    </div>
                  </div>

                  {/* Old unused ledger/extra tab kept to preserve design */}
                  <div className="tab-pane" id="Transactions">
                    <div className="tab-content">
                      <div className="tab-pane active" id="Ledger"></div>
                      <div className="tab-pane" id="Transactions2">
                        <div className="wallet_box">
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Created</th>
                                  <th>Deposit</th>
                                  <th>Withdraw</th>
                                  <th className="tr">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Nov 20, 2020</td>
                                  <td>200</td>
                                  <td>Description </td>
                                  <td className="tr">0</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </DocumentMeta>
  );
};

export default SpotHistoryFunction;
